import * as React from "react";
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import { Col, Select, Button } from 'antd';
import "./ExpenseAddCategoryAndValue.scss";
import { PbrSelect } from '../../PbrSelect/PbrSelect';
import { ExpenseCategoryEnum, ExpenseCategoryLabel } from 'src/services/Enum/ExpenseCategoryEnum';
import { PbrInputMoney } from '../../PbrInputMoney/PbrInputMoney';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormComponentProps } from 'antd/lib/form';
import { useState, useEffect } from 'react';
import { ShowNotification } from '../../ShowNotification/ShowNotification';
import { IExpenseItemCreate } from 'src/services/interfaces/Expense/IExpenseItemCreate';

interface IExpenseAddCategoryAndValueProps extends FormComponentProps {
    expenseItem: IExpenseTradeItemCreate;
    defaultCategory?: ExpenseCategoryEnum;
    onItemUpdate: (tradeId: number, expenseItem: IExpenseItemCreate) => void;
}

export const ExpenseAddCategoryAndValue: React.FC<IExpenseAddCategoryAndValueProps> = ({
    expenseItem,
    onItemUpdate,
    defaultCategory,
    form
}) => {
    const [category, setCategory] = useState<ExpenseCategoryEnum>(defaultCategory);
    const [itemValue, setItemValue] = useState<number>(undefined);

    useEffect(() => { setItemValue(expenseItem.value) }, [])

    function addCategoryAndValue() {
        if (expenseItem.listCategories.some((obj) => obj.category === category)) {
            ShowNotification.Warn("Categoria já inserida no trade!", "Esse trade já tem item com essa categoria, verifique em seu trade.");
        }
        if (!category) {
            ShowNotification.Warn("Categoria vazia!", "Selecione uma categoria, por favor.");
        }
        if (!itemValue) {
            ShowNotification.Warn("Valor deve ser maior que zero!", "Digite um valor, por favor.");
        }

        if (category && itemValue && !expenseItem.listCategories.some((obj) => obj.category === category)) {
            onItemUpdate(expenseItem.tradeId, { category, value: itemValue });
            setCategory(ExpenseCategoryEnum.COMISSAO);
            setItemValue(null);
        }
    }

    return (
        <div className="add-category-and-value">
            <Col xs={24} sm={24} md={12} lg={12}>
                <PbrSelect
                    name="expenseCategoryItem"
                    formItemProps={{ label: "Categoria" }}
                    placeholder="Selecione a Categoria"
                    value={category}
                    onChange={e => setCategory(e as ExpenseCategoryEnum)}
                    showSearch
                    defaultValue={defaultCategory}
                >
                    {Object.keys(ExpenseCategoryEnum).map(val => (
                        <Select.Option key={val} value={val}>
                            {ExpenseCategoryLabel.get(ExpenseCategoryEnum[val])}
                        </Select.Option>
                    ))}
                </PbrSelect>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8}>
                <PbrInputMoney
                    name={`Valor ${expenseItem.tradeId}`}
                    formWrapper={form}
                    formItemProps={{ label: "Valor" }}
                    placeholder="Digite o Valor"
                    value={itemValue}
                    onChange={e => setItemValue(e)}
                />
            </Col>
            <Col xs={24} sm={24} md={4} lg={4} className="add-button-category">
                <Button className="icon-only add btn" onClick={() => addCategoryAndValue()}>
                    <FontAwesomeIcon icon={faPlus} />
                </Button>
            </Col>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/common/ExpenseItemCard/ExpenseAddCategoryAndValue/ExpenseAddCategoryAndValue.tsx